type HttpErrorLike = {
    status?: number;
    response?: { status?: number };
};

export function httpErrorStatus(error: unknown): string | undefined {
    if (!error || typeof error !== 'object') {
        return undefined;
    }

    const httpError = error as HttpErrorLike;
    const status = httpError.status ?? httpError.response?.status;
    return status == null ? undefined : String(status);
}
